'use strict';

sellerService.$inject = ["common", "Seller", "$http", "api", "$q", "$cacheFactory", "SellerOverview", "SellerBanner", "SellerContact", "SellerPublic", "ProductOverviewItem", "Cart", "$localStorage", "productService", "Contract", "ContractDetail", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerService = sellerService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function sellerService(common, Seller, $http, api, $q, $cacheFactory, SellerOverview, SellerBanner, SellerContact, SellerPublic, ProductOverviewItem, Cart, $localStorage, productService, Contract, ContractDetail, authService) {
    var cache = $cacheFactory('sellerCache');

    return {
        getAll: getAll,
        getById: getById,
        getBySellerId: getBySellerId,
        getSellerAbout: getSellerAbout,
        getSellerBanners: getSellerBanners,
        getSellerProducts: getSellerProducts,
        getSellerContact: getSellerContact,
        getSellerPublic: getSellerPublic,
        getModules: getModules,
        getSellerTotalPriceDiscounts: getSellerTotalPriceDiscounts,
        getSellerContract: getSellerContract,
        getSellerContracts: getSellerContracts,
        getSellerProductsAndDiscounts: getSellerProductsAndDiscounts,
        getAllForMenu: getAllForMenu,
        getOutletSellerId: getOutletSellerId
    };

    function getById(id) {
        return getAll().then(function (sellers) {
            return _lodash2.default.find(sellers, { id: parseInt(id) });
        });
    }
    function getOutletSellerId() {
        return api.outletSeller.get().$promise.then(function (seller) {
            return seller.id;
        });
    }

    function getAll() {
        var cachedSellers = cache.get('sellers ' + common.localization.getCurrentLanguage());

        if (!angular.isUndefined(cachedSellers)) {
            return $q.when(cachedSellers);
        }

        return api.sellers.list().$promise.then(function (resourceList) {
            var sellers = _lodash2.default.map(resourceList, function (resource) {
                return Seller.create(resource);
            });

            cache.put('sellers ' + common.localization.getCurrentLanguage(), sellers);
            return sellers;
        }).catch(function () {});
    }

    function getAllForMenu() {
        var cachedSellers = cache.get('menuSellers&lang=' + common.localization.getCurrentLanguage());

        if (!angular.isUndefined(cachedSellers)) {
            return $q.when(cachedSellers);
        }

        return api.menuSellers.list().$promise.then(function (resourceList) {
            var sellers = _lodash2.default.map(resourceList, function (resource) {
                return Seller.create(resource);
            });

            cache.put('menuSellers&lang=' + common.localization.getCurrentLanguage(), sellers);
            return sellers;
        }).catch(function () {});
    }

    function getBySellerId(sellerId) {
        return api.sellers.get({ id: sellerId }).$promise.then(function (resource) {
            return SellerOverview.create(resource);
        });
    }
    function getModules(sellerId) {
        return api.sellerModules.get({ id: sellerId }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getSellerBanners(sellerId) {
        return api.sellerBanners.get({ id: sellerId }).$promise.then(function (resources) {
            return resources.banners.map(function (resource) {
                return SellerBanner.create(resource);
            });
        });
    }

    function getSellerProductsAndDiscounts(sellerId, productsModel, discountsModel) {

        var promises = [];
        promises.push(api.sellerProductsAndDiscounts.get({ id: sellerId }).$promise);
        if (authService.isBuyer) {
            promises.push(api.shoppingCartProducts.get({}).$promise);
        }
        return $q.all(promises).then(function (results) {
            var productsAndDiscounts = results[0];
            var cartProducts = results[1];

            productsModel.products = productsAndDiscounts.products.map(function (resource) {
                return ProductOverviewItem.getClass().create(resource, cartProducts);
            });
            discountsModel.products = productsAndDiscounts.discounts.map(function (resource) {
                return ProductOverviewItem.getClass().create(resource, cartProducts);
            });

            productService.calculateGrossProfits(productsModel.products);
            productService.calculateGrossProfits(discountsModel.products);

            return {
                productsModel: productsModel,
                discountsModel: discountsModel
            };
        });
    }

    function getSellerTotalPriceDiscounts(sellerId) {
        return api.totalPriceDiscounts.get({ id: sellerId }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getSellerProducts(sellerId) {
        return api.sellerBanners.get({ id: sellerId }).$promise.then(function (resource) {
            var cart = null;
            if ($localStorage.cart) {
                cart = Cart.createFromLocalStorage($localStorage.cart);
            }
            var sellerProducts = _lodash2.default.map(resource.products, function (response) {
                return ProductOverviewItem.getClass().create(response, cart);
            });
            return {
                totalItems: resource.products.count,
                products: sellerProducts,
                filters: null
            };
        });
    }

    function getSellerAbout(sellerId) {
        return api.sellerAbout.get({ id: sellerId }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getSellerContact(sellerId) {
        return api.sellerContact.get({ id: sellerId }).$promise.then(function (resource) {
            return SellerContact.create(resource);
        });
    }

    function getSellerContract(sellerId, contractId) {
        return api.sellerContract.get({ sellerId: sellerId, contractId: contractId }).$promise.then(function (resource) {
            return ContractDetail.create(resource);
        });
    }

    function getSellerContracts(sellerId) {
        return api.sellerContracts.list({ sellerId: sellerId }).$promise.then(function (resources) {
            return resources.map(function (resource) {
                return {
                    type: resource.portalContractType,
                    contracts: resource.contracts.map(function (x) {
                        return Contract.create(x);
                    })
                };
            });
        });
    }

    function getSellerPublic(sellerId) {
        return api.sellerPublic.get({ id: sellerId }).$promise.then(function (resource) {
            return SellerPublic.create(resource);
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/sellerService.js
// module id = 830
// module chunks = 0